import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import '../../../../assets/css/admin/dashboard/EventTypes.css';
import AdminLayout from '../../../../layouts/admin/AdminLayout';

const EventTypes = () => {

  const eventTypes = [
    { id: 1, name: 'Mehndi',     slug: 'mehndi',     events: 42 },
    { id: 2, name: 'Barat',      slug: 'barat',      events: 39 },
    { id: 3, name: 'Walima',     slug: 'walima',     events: 33 },
    { id: 4, name: 'Engagement', slug: 'engagement', events: 26 },
    { id: 5, name: 'Nikkah',     slug: 'nikkah',     events: 23 },
    { id: 6, name: 'Reception',  slug: 'reception',  events: 13 },
  ];

  const [sgcShowAdd,  setSgcShowAdd]  = useState(false);
  const [sgcShowEdit, setSgcShowEdit] = useState(false);

  // ── NEW: page-level loading (same pattern as Blogs Management) ──
  const [isPageLoading, setIsPageLoading] = useState(true);

  // ── NEW: button loading for Add New (same pattern as Blogs' New Post) ──
  const [navLoading, setNavLoading] = useState(null);

  useEffect(() => {
    // TODO: replace with real API call (e.g. axios.get(`${baseUrl}/admin/eventtypes/viewAll`))
    const timer = setTimeout(() => setIsPageLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  const handleAddNew = () => {
    setNavLoading('add');
    setTimeout(() => {
      setSgcShowAdd(true);
      setNavLoading(null);
    }, 600);
  };

  return (
    <AdminLayout>
      <div className="et-wrapper">
        <Container fluid>

          {/* HEADER */}
          <div className="et-header">
            <div>
              <h2 className="et-title">Event Types</h2>
              <p className="et-subtitle">Manage supported wedding event types.</p>
            </div>
            <button className="et-add-btn" onClick={handleAddNew} disabled={navLoading === 'add'}>
              {navLoading === 'add' ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                <>
                  <FiPlus size={15} /> Add New
                </>
              )}
            </button>
          </div>

          {/* TABLE CARD */}
          {isPageLoading ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <div className="spinner-border" role="status" style={{ color: '#ff8a8a' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p style={{ marginTop: '12px', color: '#888' }}>Loading event types...</p>
            </div>
          ) : (
          <Row>
            <Col xs={12}>
              <div className="et-card">
                <div className="table-responsive">
                  <table className="et-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Slug</th>
                        <th>Events</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventTypes.map((et) => (
                        <tr key={et.id}>
                          <td className="et-name">{et.name}</td>
                          <td className="et-slug">{et.slug}</td>
                          <td className="et-events">{et.events}</td>
                          <td>
                            <div className="et-actions">
                              <button className="et-edit-btn" onClick={() => setSgcShowEdit(true)}>
                                <FiEdit2 />
                              </button>
                              <button className="et-delete-btn">
                                <FiTrash2 />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
          )}

        </Container>
      </div>

      {/* ADD MODAL */}
      {sgcShowAdd && createPortal(
        <div className="et-modal-overlay" onClick={() => setSgcShowAdd(false)}>
          <div className="et-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="et-modal-header">
              <div>
                <h5 className="et-modal-title">Add New Event Type</h5>
                <p className="et-modal-subtitle">Fill in the details to create a new event type.</p>
              </div>
              <button className="et-modal-close" onClick={() => setSgcShowAdd(false)}>×</button>
            </div>

            <div className="et-modal-body">

              <div className="et-form-group">
                <label className="et-form-label">Name</label>
                <input className="et-form-input et-input-focus" type="text" placeholder="Name" />
              </div>

              <div className="et-form-group">
                <label className="et-form-label">Slug</label>
                <input className="et-form-input" type="text" placeholder="Slug" />
              </div>

              <div className="et-form-group">
                <label className="et-form-label">Events</label>
                <input className="et-form-input" type="number" placeholder="Events" />
              </div>

            </div>

            <div className="et-modal-footer">
              <button className="et-modal-cancel-btn" onClick={() => setSgcShowAdd(false)}>Cancel</button>
              <button className="et-modal-save-btn">Create</button>
            </div>

          </div>
        </div>,
        document.body
      )}

      {/* EDIT MODAL */}
      {sgcShowEdit && createPortal(
        <div className="et-modal-overlay" onClick={() => setSgcShowEdit(false)}>
          <div className="et-modal-box" onClick={(e) => e.stopPropagation()}>

            <div className="et-modal-header">
              <div>
                <h5 className="et-modal-title">Edit Event Type</h5>
                <p className="et-modal-subtitle">Update the details of this event type.</p>
              </div>
              <button className="et-modal-close" onClick={() => setSgcShowEdit(false)}>×</button>
            </div>

            <div className="et-modal-body">

              <div className="et-form-group">
                <label className="et-form-label">Name</label>
                <input className="et-form-input et-input-focus" type="text" placeholder="Name" />
              </div>

              <div className="et-form-group">
                <label className="et-form-label">Slug</label>
                <input className="et-form-input" type="text" placeholder="Slug" />
              </div>

              <div className="et-form-group">
                <label className="et-form-label">Events</label>
                <input className="et-form-input" type="number" placeholder="Events" />
              </div>

            </div>

            <div className="et-modal-footer">
              <button className="et-modal-cancel-btn" onClick={() => setSgcShowEdit(false)}>Cancel</button>
              <button className="et-modal-save-btn">Update</button>
            </div>

          </div>
        </div>,
        document.body
      )}

    </AdminLayout>
  );
};

export default EventTypes;